export default {
  install(Vue) {
    Vue.prototype.$downloadFile = (
      blobData,
      fallbackFilename,
      contentDisposition,
      mimeType = ""
    ) => {
      let fileName = fallbackFilename;

      // Tente d'extraire le nom réel depuis Content-Disposition
      if (contentDisposition) {
        const match = contentDisposition.match(
          /filename[^;=\n]*=(['"]?)([^'"\n]*)\1/
        );
        if (match && match[2]) {
          fileName = decodeURIComponent(match[2]);
        }
      }

      const blob = new Blob([blobData], { type: mimeType });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);
    };
  },
};
